const { atom } = require("recoil");


export const userState = atom({
  key: 'userState',
  default: {}
});

export const changeState = atom({
  key: 'changeState',
  default: null,
});
